import { Backdrop, OutlinedInput, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import React from "react";
import EvrbedSwitch from "../../../../components/Switch/EvrbedSwitch";

import { useTheme } from "@mui/styles";

import BackgroundStepNumber from "../common/BackgroundStepNumber";
import BedBuilderHeader from "../common/BedBuilderHeader";
import UnitInput from "../../../../components/Inputs/UnitInput";
import ImperialInput from "../../../../components/Inputs/ImperialInput";

import { useDispatch, useSelector } from "react-redux";

import {
  isSingleSleeperSelector,
  mattressConfigurationSelector,
  primarySleeperHeightSelector,
  primarySleeperHeightFeetSelector,
  primarySleeperHeightInchesSelector,
  primarySleeperUnitSystemSelector,
  primarySleeperWeightSelector,
  secondarySleeperUnitSystemSelector,
  setPrimarySleeperUnitSystem,
  setSecondarySleeperUnitSystem,
  updateMattressConfiguration,
} from "../../../../redux/slices/mattressConfiguration";

import {
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../../../redux/slices/customer";
import {
  setCurrentStepSingleSleeperMattressBuilder,
  setCurrentlyEditingSleeper, checkErrorsSelector,
} from "../../../../redux/slices/customNavigation";
import BedBuilderNextButton from "../common/BedBuilderNextButton";

import BodyTypeRadioGroup from "./BodyTypeRadioGroup";

import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";
import {saveMattressConfigurationToLocalStorage} from "../../../../utils/bedBuilder.utils";

const StyledContainer = styled.div`
  position: absolute;
  left: 0;
  top: 35%;
  width: 100%;
  height: 66%;
  overflow: auto;
`;

const StyledSettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const StyledHeightWeightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledInputLabel = styled.div`
  font-family: noto-sans;
`;

const SingleSleeperHeightAndWeight = ({ currentStep, index }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  const primarySleeperHeight = useSelector(primarySleeperHeightSelector);
  const primarySleeperHeightFeet = useSelector(primarySleeperHeightFeetSelector);
  const primarySleeperHeightInches = useSelector(primarySleeperHeightInchesSelector);
  // console.log("=>(SingleSleeperHeightAndWeight.js:83) primarySleeperHeight", primarySleeperHeight);
  const primarySleeperWeight = useSelector(primarySleeperWeightSelector);
  const primarySleeperMetricSystem = useSelector(
    primarySleeperUnitSystemSelector
  );
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const primarySleeperUnitSystem = useSelector(
    primarySleeperUnitSystemSelector
  );
  const secondarySleeperUnitSystem = useSelector(
    secondarySleeperUnitSystemSelector
  );

  const isCurrentlyEditingSleeperPrimary = true;

  const handleOnChange = event => {
    if (isSingleSleeper) {
      dispatch(setPrimarySleeperUnitSystem(!event.target.checked));
    } else {
      dispatch(setSecondarySleeperUnitSystem(!event.target.checked));
    }
  };
  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const handleUpdateMattressConfiguration = () => {
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };

  const switchValue = isSingleSleeper
    ? primarySleeperUnitSystem
    : isCurrentlyEditingSleeperPrimary
    ? primarySleeperUnitSystem
    : secondarySleeperUnitSystem;

  return (
    <>
      <StyledContainer style={{ zIndex: 500, overflow: "visible" }}>
        <BackgroundStepNumber>{t("1")}</BackgroundStepNumber>
      </StyledContainer>
      <StyledContainer style={{ zIndex: 600, overflow: "hidden" }}>
        <StyledSettingsContainer className="px-3">
          <BedBuilderHeader styles={{ marginTop: "0rem" }}>
            {t("Let's Calculate Your evr-index:")}
          </BedBuilderHeader>
          <EvrbedSwitch
            labelLeft={t("Imperial")}
            labelRight={t("Metric")}
            textStyles={{ color: theme.COLORS.BLUE.darkBlueGreen }}
            containerStyles={{ marginTop: "1rem" }}
            onChange={handleOnChange}
            value={switchValue !== "imperial"}
          ></EvrbedSwitch>
          <StyledHeightWeightContainer className="row mt-3 mx-5 height-and-weight">
            <div className="col-5">
              <StyledInputLabel
                style={{
                  color: theme.COLORS.BLUE.darkBlueGreen,
                }}
              >
                {t("Height")}
              </StyledInputLabel>
              {primarySleeperMetricSystem === "metric" &&
                <UnitInput
                  unit="height"
                  label={"Height"}
                  value={primarySleeperHeight}
                  placeholder={
                    primarySleeperMetricSystem === "metric" ? "cm" : "' \""
                  }
                />
              }
              {primarySleeperMetricSystem !== "metric" &&
                <>
                  <ImperialInput
                    unit="height"
                    label={"Height"}
                    value={primarySleeperHeightFeet}
                    placeholder={"feet"}
                  />
                  <ImperialInput
                    unit="height"
                    label={"Height"}
                    value={primarySleeperHeightInches}
                    placeholder={"inches"}
                  />
                </>
              }
            </div>
            <div className="col-5">
              <StyledInputLabel
                style={{
                  color: theme.COLORS.BLUE.darkBlueGreen,
                }}
              >
                {t("Weight")}
              </StyledInputLabel>
              <UnitInput
                unit="weight"
                label={"Weight"}
                value={primarySleeperWeight}
                placeholder={
                  primarySleeperMetricSystem === "metric" ? "kg" : "lbs"
                }
              />
            </div>
          </StyledHeightWeightContainer>
          <BedBuilderHeader styles={{ marginTop: "0.5rem" }}>
            {t("What Is Your Body Type?")}
          </BedBuilderHeader>
          <BodyTypeRadioGroup />
          <div
            style={
              isMediumScreen
                ? { width: "98%" }
                : { marginTop: "1rem", width: "100%", marginBottom: "2rem" }
            }
          >
            <BedBuilderNextButton
              styles={{
                position: "relative",
                bottom: "5%",
                right: "5%",
              }}
              onClick={() => {
                //Update in local storage
                // console.log("saving to local storage");
                saveMattressConfigurationToLocalStorage(mattressConfiguration);
                handleUpdateMattressConfiguration();
                dispatch(
                  setCurrentStepSingleSleeperMattressBuilder(currentStep + 1)
                );
              }}
            ></BedBuilderNextButton>
          </div>
        </StyledSettingsContainer>
      </StyledContainer>
    </>
  );
};

export default SingleSleeperHeightAndWeight;
